@import "../../variables.scss";

.dropzone {
  @media (min-width: $size-lg) {
    overflow-y: auto;
    max-height: 62vh;
  }
}
